import { usePage } from '@inertiajs/inertia-react';

export function usePageProps<T>() {
    // @ts-ignore
    return usePage<Inertia.PageProps & { props: T }>().props;
}
